var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.606 -15.4072H32.3962C5.99332 -15.4072 -15.4062 5.99234 -15.4062 32.3952V223.605C-15.4062 250.008 5.99332 271.408 32.3962 271.408H223.606C250.009 271.408 271.409 250.008 271.409 223.605V32.3952C271.409 5.99234 250.009 -15.4072 223.606 -15.4072Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.606 255.474H32.3957C14.7964 255.474 0.527344 241.205 0.527344 223.606V32.3957C0.527344 14.7964 14.7964 0.527344 32.3957 0.527344H223.606C241.205 0.527344 255.474 14.7964 255.474 32.3957V223.606C255.474 241.205 241.205 255.474 223.606 255.474Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.672 191.299H68.2453C66.0463 191.299 64.2617 189.515 64.2617 187.316V60.2726C64.2617 58.0737 66.0463 56.2891 68.2453 56.2891H83.5022C85.7011 56.2891 87.4858 58.0737 87.4858 60.2726V162.65C87.4858 164.848 89.2704 166.633 91.4693 166.633H121.672C123.871 166.633 125.656 168.418 125.656 170.617V187.316C125.656 189.515 123.871 191.299 121.672 191.299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.732 121.72C189 119.776 185.813 118.804 182.172 118.804C177.24 118.804 173.376 121.171 170.604 125.911C167.815 130.651 166.437 137.097 166.437 145.263V187.313C166.437 189.512 164.652 191.297 162.453 191.297H147.698C145.499 191.297 143.715 189.512 143.715 187.313V98.8708C143.715 96.6719 145.499 94.8873 147.698 94.8873H162.453C164.652 94.8873 166.437 96.6719 166.437 98.8708V112.773H166.724C170.317 99.7233 176.786 93.1982 186.14 93.1982C188.53 93.1982 190.402 93.5727 191.74 94.3296V121.72H191.732Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightroom);
export default __webpack_public_path__ + "static/media/lightroom.424c831226bb54a0403873714cec6f38.svg";
export { ForwardRef as ReactComponent };